import APIClient from '@/shared/http/clients/api'

const resourceName = 'PDRRelatorioFuncaoObra'
const APIPci = process.env.APIBaseURLPci

const GetAllGoal = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/meta`, data, config)
const GetAllReports = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorio`, data, config)
const GetWorkCoordinators = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/coordenadores/${data.workPositionId}/${data.startDate}/${data.endDate}`, data, config)
const GetReport = (pdrWorkPositionReportId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorio/${pdrWorkPositionReportId}`, data, config)
const CreateGoal = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/meta`, data, config)
const CreateReport = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/relatorio`, data, config)

const PDRWorkPositionReportRepository = {
  GetAllGoal,
  GetAllReports,
  GetWorkCoordinators,
  GetReport,
  CreateGoal,
  CreateReport
}
export default PDRWorkPositionReportRepository



//////////////////
// WEBPACK FOOTER
// ./src/shared/http/repositories/pci/pdrworkpositionreport
// module id = null
// module chunks = 